import useSWR, { trigger } from "swr";
import Manager from "../manager/Manager.api";
import Endpoints from "../endpoints/Endpoints.api";

const installers = (token) =>
  Manager.client(token).get(Endpoints.users.installers);
const updateInstaller = (token, values) =>
  Manager.client(token).post(Endpoints.users.updateInstaller, values);
const deleteInstaller = (token, id) =>
  Manager.client(token).delete(`${Endpoints.users.deleteInstaller}${id}/`);
const refreshInstallers = (token) =>
  trigger(`${Endpoints.users.installers}/${token.access}`);

export const UseInstallers = ({ access }) => {
  const { data, error } = useSWR(
    `${Endpoints.users.installers}/${access}`,
    () => installers(access),
  );

  return {
    content: data ? data.data.data : [],
    error,
    loading: !error && !data,
    trigger: () => trigger(`${Endpoints.users.installers}/${access}`),
  };
};

export const Request = {
  updateInstaller,
  refreshInstallers,
  deleteInstaller,
};
